import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { Subject } from 'rxjs';
import { PopoverService } from 'app/core/services/popover.service';
import { Store } from '@ngrx/store';
import { ModalAuctionUpdateEmailService } from '../../services/modal-auction-update-email/modal-auction-update-email.service';
import { ModalAuctionSeeBidderInfoService } from '../../services/modal-auction-see-bidder-info/modal-auction-see-bidder-info.service';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ConfirmModalComponent } from 'app/core/components/modals/confirm-modal/confirm-modal.component';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import { deleteAutoBid, deleteBid } from '../../features/auction.actions';
import _ from 'lodash';

let id = 1;

@Component({
  selector: 'app-auction-bidder-popover',
  templateUrl: './auction-bidder-popover.component.html',
  styleUrls: ['./auction-bidder-popover.component.scss']
})


export class AuctionBidderPopoverComponent implements OnInit {

  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() data;
  @Input() auctionCampaign;

  private _id = id++;
  
  get id() {
    return `P2PPopoverEvent_${this._id}`;
  }

  public isModalOpen: boolean = false;
  public isAuctionEnded: boolean = false;
  public isAutoBidExhausted: boolean = false;

  public takeUntilSubject: Subject<any> = new Subject();

  modalRef: MdbModalRef<ConfirmModalComponent> | null = null;

  public params: any = null;

  constructor(
    private popoverService: PopoverService,
    private store: Store,
    public modalAuctionUpdateEmailService: ModalAuctionUpdateEmailService,
    public modalAuctionSeeBidderInfoService: ModalAuctionSeeBidderInfoService,
    private modalService: MdbModalService,
    private auctionManageService:AuctionManageService,

  ) { }

  ngOnInit(): void {
    this.params = {
      auctionType: this.auctionCampaign.campaignTypeData.auctionType,
      campaignId: this.auctionCampaign.id,
      presetId: this.data.presetId,
      status: this.auctionCampaign.campaignTypeData.auctionStatus
    }

    this.isAutoBidExhausted = this.data.exhausted ? true : false;
    this.isAuctionEnded = this.auctionCampaign.campaignTypeData.auctionStatus == 2 ? true : false;
  }

  updateBidderEmail() {
    this.isModalOpen = true;

    const data = {
      bid: this.data,
      auctionCampaign: this.auctionCampaign
    }

    const modalRef = this.modalAuctionUpdateEmailService.open(data);
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalAuctionUpdateEmailService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  seeBidInfo() {
    this.isModalOpen = true;

    const modalRef = this.modalAuctionSeeBidderInfoService.open(this.data, this.auctionCampaign);
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalAuctionSeeBidderInfoService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  deleteBid() {
    const bid = this.data;

    const isAutoBid = _.has(bid, 'isAutoBid') ? false : true;

    let message = '';

    if(isAutoBid) {
      message = `This action will stop any further autobids for <b>${bid.userInfo.name}</b>, it will not remove the past bids.`;
      this.deleteAutoBidById(bid, message);
    } else {
      message = `Remove ${bid.userInfo.name}'s bid of <b>${this.getNumberStr(bid.amount)}</b> permanently.`;
      this.deleteBidById(bid, message);
    }
  }

  deleteBidById(bid, message){
    this.modalRef =  this.modalService.open(ConfirmModalComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee modal-sm',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Are you sure?',
        text: message,
        onClose: (status)=>{
          this.modalRef.close()
          if(status){
            this.store.dispatch({
              type: deleteBid.type,
              payload: {
                bidId: bid.id,
                campaignId: this.auctionCampaign.id,
                loadItemParams: this.params
              }
            });
          }
        }
      }
    });
  }

  deleteAutoBidById(autoBid, message){
    this.modalRef =  this.modalService.open(ConfirmModalComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee modal-sm',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Are you sure?',
        text: message,
        onClose: (status)=>{
          this.modalRef.close()
          if(status){
            this.store.dispatch({
              type: deleteAutoBid.type,
              payload: {
                autoBidId: autoBid.id,
                campaignId: this.auctionCampaign.id,
                loadItemParams: this.params
              }
            });
          }
        }
      }
    });
  }

  getNumberStr(number){
    return this.auctionManageService.addCommasToNumber(number)
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }
}
